<template>
  <div class="registration-form" v-loading="fetchingDetails">
    <page-header
      title="Promotions"
      breadcrumb="CRM  > Promotions > Create New Promotion"
    />

    <div class="card">
      <div class="flex justify-between">
        <div>
          <p class="text-deepBlue font-semibold">Promo Details</p>
        </div>
        <div>
          <img src="@/assets/images/icons/info.svg" alt="information icon" />
        </div>
      </div>

      <div class="basic-info-form container-fluid">
        <div class="row">
          <div class="col-12 col-md-6 col-lg-4">
            <label class="label">Promo Name:</label>
            <input
              type="text"
              class="input"
              placeholder="Enter Promo Name"
              v-model="promotion.name"
            />
          </div>
          <div class="col-12 col-md-6 col-lg-4">
            <label class="label">Promo Reference Code:</label>
            <input
              type="text"
              class="input"
              placeholder="Enter Promo Code"
              v-model="promotion.promoCode"
            />
          </div>
          <div class="col-12 col-md-6 col-lg-4">
            <label class="label">Target Audience:</label>
            <el-select v-model="promotion.contactCategory" placeholder="Select">
              <el-option
                v-for="audience in targetAudiences"
                :key="audience"
                :label="audience"
                :value="audience"
              >
              </el-option>
            </el-select>
          </div>
          <div class="col-12 col-md-6 col-lg-4">
            <label class="label">Start Date:</label>
            <el-date-picker
              v-model="promotion.startDate"
              type="date"
              placeholder="Pick start date"
            >
            </el-date-picker>
          </div>
          <div class="col-12 col-md-6 col-lg-4">
            <label class="label">End Date:</label>
            <el-date-picker
              v-model="promotion.endDate"
              type="date"
              placeholder="Pick end date"
            >
            </el-date-picker>
          </div>
          <div class="col-12 col-md-6 col-lg-4">
            <label class="label"
              >Loyalty Scheme:
              <span
                class="text-xs underline cursor-pointer"
                @click="isLoyaltySchemeModal = true"
                >Set Up a Loyalty Scheme</span
              ></label
            >
            <el-select v-model="promotion.loyaltySchemeId" placeholder="Select">
              <el-option
                v-for="scheme in loyaltySchemes"
                :key="scheme.id"
                :label="scheme.loyaltyCategory"
                :value="scheme.id"
              >
              </el-option>
            </el-select>
          </div>
          <div class="col-12 col-md-6 col-lg-4">
            <label class="label">Standard Promo Discount (%):</label>
            <input
              type="number"
              class="input"
              placeholder="Enter Discount"
              @keydown="isNumber($event)"
              v-model="promotion.promoDiscount"
            />
          </div>
          <div class="col-12 col-md-6 col-lg-4">
            <label class="label">Reason:</label>
            <input
              type="text"
              class="input"
              placeholder="Enter Reasn"
              v-model="promotion.reason"
            />
          </div>
        </div>
      </div>

      <hr class="my-8" />

      <div>
        <div>
          <p class="text-deepBlue font-semibold">Promo Item(s)</p>
        </div>

        <div class="mt-4">
          <table class="w-full text-deepBlue">
            <thead>
              <tr>
                <th>#</th>
                <th>Item Name</th>
                <th>Item Category</th>
                <th>Promo Discount (%)</th>
                <th class="text-center">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(service, index) in promotion.promoItems"
                :key="service.id"
              >
                <td>{{ index + 1 }}</td>
                <td>
                  {{ service.takeOffLocation }} - {{ service.arrivalLocation }}
                </td>
                <td>Route</td>
                <td>
                  <input
                    type="text"
                    class="input service-input w-4/5"
                    v-model="promotion.promoDiscount"
                    disabled
                  />
                </td>
                <td
                  class="text-center flex justify-center items-center cursor-pointer"
                  @click="removeService(index)"
                >
                  <svg
                    width="12"
                    height="16"
                    viewBox="0 0 12 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0.857143 14.0004C0.857143 14.9433 1.62857 15.7147 2.57143 15.7147H9.42857C10.3714 15.7147 11.1429 14.9433 11.1429 14.0004V3.7147H0.857143V14.0004ZM2.57143 5.42899H9.42857V14.0004H2.57143V5.42899ZM9 1.14328L8.14286 0.286133H3.85714L3 1.14328H0V2.85756H12V1.14328H9Z"
                      fill="#A5ADB7"
                    />
                  </svg>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="my-6" v-if="!promotion.promoItems.length">
            <p class="text-center">No products selected!</p>
          </div>
        </div>
      </div>

      <hr class="my-4" />
      <div class="mt-2">
        <p
          class="font-semibold cursor-pointer"
          @click="showServices = !showServices"
        >
          <span v-if="showServices">Hide</span>
          <span v-else>Add an Item/Service</span>
        </p>
      </div>

      <div class="container-fluid mt-6" v-if="showServices">
        <div class="row">
          <div class="table__search-input-wrapper w-2/4">
            <span class="pr-2 opacity-50"><search-icon /> </span>

            <input
              type="text"
              class="table__search-input"
              placeholder="Search..."
              v-model="query"
            />
            <img src="@/assets/images/icons/search.svg" alt="search icon" />
          </div>
        </div>
        <div class="row">
          <div class="my-2">
            <p>Selected Products ({{ promotion.promoItems.length }}):</p>
          </div>
        </div>
        <div class="row">
          <p class="font-semibold">All Services</p>
        </div>
        <div
          class="row mt-4"
          v-for="(service, index) in services"
          :key="service.id"
        >
          <div class="col-8 col-md-8 col-lg-8">
            <p class="capitalize font-semibold">
              {{ index + 1 }}. {{ service.takeOffLocation }} -
              {{ service.arrivalLocation }}
            </p>
            <p class="text-sm">
              Item description: {{ service.takeOffTime }} -
              {{ service.arrivalTime }}
            </p>
          </div>
          <div class="col-4 col-md-4 col-lg-4" @click="selectService(service)">
            <p class="cursor-pointer font-semibold">Add Item</p>
          </div>
        </div>
      </div>

      <div class="actions flex justify-between my-12">
        <div
          class="cursor-pointer"
          @click="$router.push({ name: 'Promotions' })"
        >
          <p>Cancel</p>
        </div>
        <!-- <div>
          Save
        </div> -->
        <div>
          <primary-button
            v-if="isEdit"
            buttonText="Update"
            :loading="loading"
            @click="updatePromo"
          />
          <primary-button
            v-else
            buttonText="Save"
            :loading="loading"
            @click="createPromo"
          />
        </div>
      </div>
    </div>
    <loyalty-scheme-form
      :show-modal="isLoyaltySchemeModal"
      @close-modal="isLoyaltySchemeModal = false"
      @scheme-created="getAllLoyaltySchemes"
    />
  </div>
</template>

<script>
import PageHeader from "@/components/UI/NewPageHeader";
import LoyaltySchemeForm from "../CustomerRegistration/Modals/CreateLoyaltyScheme";

export default {
  components: {
    PageHeader,
    LoyaltySchemeForm,
  },
  data() {
    return {
      promotion: {
        name: "",
        loyaltySchemeId: "",
        startDate: "",
        endDate: "",
        promoCode: "",
        status: "",
        reason: "",
        contactCategory: "",
        promoDiscount: "",
        promoItems: [],
      },
      targetAudiences: ["retail", "wholesale", "all"],
      isLoyaltySchemeModal: false,
      loyaltySchemes: [],
      services: [],
      selectedServices: [],
      loading: false,
      showServices: false,
      query: "",
      fetchingDetails: false,
      isEdit: false,
    };
  },
  computed: {
    filteredServices() {
      return this.filterArray(this.services, this.query);
    },
  },
  watch: {},
  mounted() {
    this.getAllLoyaltySchemes();
    this.getAllServices();
    if (this.$route.query.id) {
      this.isEdit = true;
      this.getPromotionDetails();
    }
  },
  methods: {
    async createPromo() {
      this.loading = true;
      let payload = this.createPayload();
      try {
        const response = await this.$_createPromotion(payload);
        this.logResponse(response);
        this.generateToast("Promotion Created!", "success");
        this.$router.push({ name: "Promotions" });
      } catch (error) {
        this.handleError(error);
      }
      this.loading = false;
    },
    async updatePromo() {
      this.loading = true;
      let payload = this.createPayload();
      try {
        const response = await this.$_updatePromotion(
          this.promotion.id,
          payload
        );
        this.logResponse(response);
        this.generateToast("Promo Updated successfully!", "success");
        this.$router.push({ name: "Promotions" });
      } catch (error) {
        this.handleError(error);
      }
      this.loading = false;
    },
    createPayload() {
      // this.promotion.promoItems = this.selectedServices;
      let payload = {
        payload: {
          ...this.promotion,
        },
      };
      return payload;
    },
    async getPromotionDetails() {
      this.fetchingDetails = true;
      let promotionId = this.$route.query.id;
      try {
        const response = await this.$_getPromotionDetails(promotionId);
        this.logResponse(response);
        this.promotion = response.data;
        // this.selectedServices = response.data.promoItems;
      } catch (error) {
        this.handleError(error);
      }
      this.fetchingDetails = false;
    },
    async getAllLoyaltySchemes() {
      try {
        const response = await this.$_getAllLoyaltySchemes();
        this.logResponse(response);
        this.loyaltySchemes = response.data;
      } catch (error) {
        this.handleError(error);
      }
    },
    async getAllServices() {
      try {
        const response = await this.$_getShippingServicesByRoute();
        this.logResponse(response);
        this.services = response.data.data.shippingServicesByRoute;
      } catch (error) {
        this.handleError(error);
      }
    },
    selectService(service) {
      if (this.promotion.promoItems.indexOf(service) < 0) {
        this.promotion.promoItems.push(service);
      }
    },
    removeService(index) {
      this.promotion.promoItems.splice(index, 1);
    },
  },
};
</script>

<style scoped>
.label {
  margin-top: 1.5rem;
}
.input {
  margin-bottom: 0;
}
.service-input {
  width: 60%;
}
td {
  padding: 0.75rem 0;
}
</style>
